var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('NavigationBar'),_c('About'),(!_vm.$store.state.closePopUp)?_c('VideoPopUp'):_vm._e(),_c('Dishes'),_c('History'),_c('Video'),_c('FoodMenu'),_c('Team'),_c('Feedback'),_c('LatestNews'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }